<template>
  <b-card title="Indicatori">
    <b-row>
      <b-col>
        <IPGBar v-show="showBar" :refreshCallback="updateParamsAndRefresh" :sites="sites" />
      </b-col>
    </b-row>
    <div ref="container"></div>
  </b-card>
</template>

<script>

import Vue from 'vue'
import IPGBar from './IPGBar'
import IPGVisual from './IPGVisual'
import { months } from 'moment';

export default {
  name: "IPG",
  components: { IPGBar, IPGVisual },
  props:[ 'monthFrom', 'monthTo', 'sites' ],

  created() {
    this.showBar = true
  },

  mounted() {
    if(this.indicators && this.indicators.length) {
      this.loadIndicators()
    }
  },
  data() {
    return {
      userReady: false,
      showBar: false,
      tempIPG: null,
      formulaId: null,
      tags: null,
      selectedSites: null,
      excludedSites: null,
      sampling: null
    }
  },
  methods: {
    updateParamsAndRefresh(formulaId, tags, selectedSites, excludedSites, sampling) {
      this.setParams(formulaId, tags, selectedSites, excludedSites, sampling)
      this.refresh()
    },
    setParams(formulaId, tags, selectedSites, excludedSites, sampling) {
      this.formulaId = formulaId
      this.tags = tags
      this.selectedSites = selectedSites
      this.excludedSites = excludedSites
      this.sampling = sampling
    },
    refresh() {
      if(! this.formulaId) {
        return
      }

    if(! this.tempIPG) {
        let visual = Vue.extend(IPGVisual)
        this.tempIPG = new visual({
            propsData: { $store: this.$store, months: this.months }
        })
        this.tempIPG.$mount() // pass nothing
        this.$refs.container.appendChild(this.tempIPG.$el)
        this.tempIPG.load(this.$store.state.customerGuid,
                          this.formulaId,
                          this.tags,
                          this.selectedSites,
                          this.excludedSites,
                          this.monthFrom,
                          this.monthTo,
                          this.sampling)
      } else {
        this.tempIPG.load(this.$store.state.customerGuid,
                          this.formulaId,
                          this.tags,
                          this.selectedSites,
                          this.excludedSites,
                          this.months,
                          this.sampling)
      }
    },
    loadIndicators() {
      this.indicators.forEach(i => {
          let visual = Vue.extend(IPGVisual)
          let v = new visual({
              propsData: {
                $store: this.$store,
                name: i.name,
                loaded: true,
                indicatorId: i.id
              }
          })
          v.$mount() // pass nothing
          this.$refs.container.appendChild(v.$el)
          v.load(this.customerGuid, i.formulaId, i.tags, i.sites, i.excludedSites, this.months)

        })
    }
  },
  computed: {
    indicators() {
      return this.$store.state.user.indicators
    }
  },
  watch: {
    months(v) {
      this.refresh()
    },
    customer(v) {
      if(v.guid) {
        this.userReady = true
        this.showBar = true
      }
    },
    indicators(v, o) {
      if(v && v.length) {
        if(! o || !o.length) {
          this.loadIndicators()
        } else {
          if(o.length != v.length) {
            this.loadIndicators()
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/IPG/IPG.vue